/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contracts_NotesInputs */

const cs_contracts_notes = /** @type {(inputs: Contracts_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznámky`)
};

const en_contracts_notes = /** @type {(inputs: Contracts_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Contracts_NotesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contracts_notes = /** @type {((inputs?: Contracts_NotesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contracts_NotesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contracts_notes(inputs)
	return cs_contracts_notes(inputs)
});